import React, { useContext, useEffect, useState } from 'react'
import { ScoreCardContext } from '../../store/scorecard-context'
import styles from './ScoreCard.module.css'
import { getCookie } from '../../utils/common'
import { conversationFeedbackAPI } from '../../services/api/conversation-feedback'
import { hasSpecialCharacters, removeHtmlTags, replaceHtmlTags } from '../Common/Common'


const Comment = ({questionUUID, sectionUUID, sectionIndex, questionIndex, onToggleComment, id}: any) => {

    const scorecardCtx = useContext(ScoreCardContext)
    let commmentTxt = removeHtmlTags(scorecardCtx.scores.sections[sectionIndex].questions[questionIndex].comment)
    const [commentText, setCommentText] = useState(commmentTxt|| '')
    const [isTyping, setIsTyping] = useState(false)
    const [isUpdateComment, setIsUpdateComment] = useState(false)
    const [updateCommentText, setUpdateCommentText] = useState('')
    const [isSendingComment, setIsSendingComment] = useState(false)
    const [CommentHasSplChar, setCommentHasSplChar] = useState("");
    
    // If clicked on "edit", isUpdateComment is set to true and updateCommentText will be set to the commentText 
    useEffect(() => {
        if(isUpdateComment) {
            setUpdateCommentText(commentText)
        }
    }, [isUpdateComment])

    useEffect(() => {
        let commmentTxt = scorecardCtx.scores.sections[sectionIndex].questions[questionIndex].comment
        setCommentText(commmentTxt || '')
    }, [questionUUID])
    

    const onChangeHandler = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
        setIsTyping(true)
        if(e.target.name === 'commentText') {
            setCommentText(e.target.value)
        } else {
            setUpdateCommentText(e.target.value)
        }
    }

    const addComment = () => {
        setCommentHasSplChar("");
        let updatedTxt = replaceHtmlTags(commentText)
        if (hasSpecialCharacters(updatedTxt)) {
            setCommentHasSplChar("Special characters are not allowed in the Comment");
            return;
        }
        let  scores = JSON.parse(JSON.stringify(scorecardCtx.scores))
        scores.sections[sectionIndex].questions[questionIndex].comment = updatedTxt
        
        scorecardCtx.updateScores(scores)
        setCommentText(updatedTxt)
    }

    const updateComment = () => {
        let updatedTxt = replaceHtmlTags(updateCommentText)
        if (hasSpecialCharacters(updatedTxt)) {
            setCommentHasSplChar("Special characters are not allowed in the Comment");
            return;
        }
        let  scores = JSON.parse(JSON.stringify(scorecardCtx.scores))
        scores.sections[sectionIndex].questions[questionIndex].comment = updatedTxt
        
        scorecardCtx.updateScores(scores)
        setCommentText(updatedTxt)
        cancelComment()
    }

    const deleteComment = () => {
        let  scores = JSON.parse(JSON.stringify(scorecardCtx.scores))
        scores.sections[sectionIndex].questions[questionIndex].comment = ''
        scorecardCtx.updateScores(scores)
        setCommentText('')
    }

    const cancelComment = () => {
        setIsUpdateComment(false)
        setUpdateCommentText('')
        setIsTyping(false)
    }

    return (
        <div className="d-flex flex-wrap justify-content-end mt-3">
            {
                scorecardCtx.scores.sections[sectionIndex].questions[questionIndex].comment && !isUpdateComment && !isTyping ?
                    <div className={`${styles.commentedSection} w-100 p-3`}>
                        { commentText }
                    </div> :
                    (
                        isUpdateComment ?
                            <textarea
                                className={`d-flex p-3 w-100 ${styles.commentTextarea} ${isTyping ? styles.isTypingComment : ''}`}
                                placeholder="You can leave a comment here (Optional)"
                                name="updateCommentText"
                                value={updateCommentText}
                                onChange={onChangeHandler}
                                onFocus={() => setIsTyping(true)}
                                onBlur={() => setIsTyping(false)}
                            /> :
                            <textarea
                                className={`d-flex p-3 w-100 ${styles.commentTextarea} ${isTyping ? styles.isTypingComment : ''}`}
                                placeholder="You can leave a comment here (Optional)"
                                name="commentText"
                                value={commentText}
                                onChange={onChangeHandler}
                                onFocus={() => setIsTyping(true)}
                                onBlur={() => setIsTyping(false)}
                            /> 
                    )
            }
            {
                scorecardCtx.scores.sections[sectionIndex].questions[questionIndex].comment && !isUpdateComment ?
                    <div>
                        <button type="button" className={`btn link-primary float-end ${styles.addCommentCTA}`} onClick={deleteComment}>Delete</button>
                        <button type="button" className={`btn link-primary float-end ${styles.addCommentCTA}`} onClick={() => setIsUpdateComment(true)}>Edit</button>
                    </div>
                    :
                    <div>
                        {
                            isUpdateComment ?
                            <>
                                {
                                    CommentHasSplChar ? 
                                    (
                                        <span className={styles.error}>{CommentHasSplChar}</span>
                                    ) : 
                                    null
                                }
                                <button type="button" className={`btn link-primary float-end ${styles.addCommentCTA}`} onClick={cancelComment}>Cancel</button>
                                <button type="button" className={`btn link-primary float-end ${styles.addCommentCTA}`} onClick={updateComment}>Update</button>
                            </>
                            :
                            <button type="button" className={`btn link-primary float-end ${styles.addCommentCTA}`} onClick={addComment}>Add Comment</button>
                        }
                    </div>
                    
            }
        </div>
    )
}

export default Comment
